import { forwardRef, useId } from 'react'
import { useAuth } from '../../App'
import { collectionDatalistItems, collectionDatalistLabel, resolveCollectionDatalist } from '../../lib/collectionDatalist'

export function CollectionDatalist({ id, items }) {
  return <datalist id={id}>{items.map(item => <option key={item.id} value={collectionDatalistLabel(item)} />)}</datalist>
}

export const CollectionSearchInput = forwardRef(function CollectionSearchInput({
  collection = [], onSelect, onChange, as: Input = 'input', useNativeDatalist = true, ...props
}, ref) {
  const id = useId()
  const { user } = useAuth()
  const items = collectionDatalistItems(collection, user?.id)
  const ambiguous = items.filter(item => collectionDatalistLabel(item) === props.value)
  return <>
    <Input
      {...props}
      ref={ref}
      {...(useNativeDatalist ? { list: id } : {
        autoCapitalize: 'none',
        autoCorrect: 'off',
        spellCheck: false,
      })}
      autoComplete="off"
      onChange={event => {
        onChange?.(event)
        const item = resolveCollectionDatalist(event.target.value, items)
        if (item) onSelect(item)
      }}
    />
    {useNativeDatalist && <CollectionDatalist id={id} items={items} />}
    {ambiguous.length > 1 && <div className="rounded-lg border border-white/10 bg-charcoal-700" aria-label="Choose a collection bottle">
      {ambiguous.map(item => <button key={item.id} type="button" onClick={() => onSelect(item)} className="block min-h-11 w-full px-3 py-2 text-left text-sm text-cream">
        {collectionDatalistLabel(item)} · {item.concentration || 'Unspecified concentration'}{item.bottle_ml ? ` · ${item.bottle_ml} ml` : ''}
      </button>)}
    </div>}
  </>
})
